<div class="text-field-wrapper">
  <div class="text-field-container" [ngClass]="{ 'error-state': !getControl().untouched && getControl().invalid }">
    <input
      [id]="'text-input-' + getUniqueId()"
      class="text-field-input"
      [type]="isPassword() ? 'password' : 'text'"
      [placeholder]="placeholder() || label() || ' '"
      [formControl]="getControl()"
      [attr.aria-invalid]="!getControl().valid && getControl().touched">
    @if (label()) {
      <label class="text-field-label" [for]="'text-input-' + getUniqueId()">
        {{ label() }}@if (required()) { <span class="required">*</span> }
      </label>
    }
  </div>
  @if (hint()) {
    <div class="text-field-hint">{{ hint() }}</div>
  }
</div>
